var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.813 0 0 3.813 0 8.5S3.813 17 8.5 17 17 13.187 17 8.5 13.187 0 8.5 0m0 16C4.364 16 1 12.636 1 8.5S4.364 1 8.5 1 16 4.364 16 8.5 12.636 16 8.5 16m.5-3.631h.979v1H7.021v-1H8v-4.42h-.946v-1H9zM7.185 4.986a.985.985 0 1 1 1.97-.001.985.985 0 0 1-1.97.001"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.svg";